
import { Component, Vue } from 'vue-property-decorator';
import Alert from '~/components/Alerts/Alert.vue';
import ConfirmPaymentDialog from '@/components/common/Dialogs/ConfirmPaymentDialog.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CurrencyInput from '~/components/Inputs/Currency.vue';
import { formattedDate } from '@/utils/dates';
import { getLoanInfo } from '@/api/loan';
import { PaymentProviderBankDetails } from '@/interfaces/bank-account';
import { LoanData } from '@/interfaces/loan';

@Component({
  components: {
    Alert,
    ConfirmPaymentDialog,
    CustomButton,
    CurrencyInput
  }
})
export default class OneTimePayment extends Vue {
  loanData: LoanData | null = null;

  paymentAmount = '';

  showPaymentForm = false;

  showPaymentConfirmation = false;

  loading = false;

  loadingPage = false;

  success = false;

  showPaymentInformation = false;

  valid = false;

  paymentId = '';

  get buttonDisabled() {
    return !this.paymentAmount.length || !this.valid;
  }

  get date() {
    return formattedDate();
  }

  get bankDetails(): PaymentProviderBankDetails {
    return this.$store.getters['Account/getBankDetails'];
  }

  get amountDue(): string {
    return `$${this.loanData?.loan_details.amount_due.toFixed(2) ?? '0.00'}`;
  }

  get payoffAmount(): string {
    return `$${this.loanData?.loan_details.pay_off_amount.toFixed(2)}`;
  }

  get getBrandName(): string {
    return this.$store.getters['Config/getBrandName'];
  }

  get getBrandLegalName(): string {
    return this.$store.getters['Config/getLegalBusinessName'];
  }

  get supportEmail() {
    return this.$store.getters['Config/getBrandSupportEmail'];
  }

  get supportPhone() {
    return this.$store.getters['Config/getBrandSupportPhone'];
  }

  async created() {
    this.loadingPage = true;
    try {
      const { data } = await getLoanInfo();
      this.loanData = data;
    } finally {
      this.loadingPage = false;
    }
  }

  showConfirmationDialog() {
    this.showPaymentConfirmation = true;
  }

  submitPayment(paymentId: string) {
    this.paymentId = paymentId;
    this.showPaymentConfirmation = false;
    this.success = true;
  }
}

